/* eslint-disable react/prop-types */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { getJson } from 'session';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function BirthContent({
  transactionInfo,
  showTransaction,
  approveTransaction,
  clearTransaction,
  getTransactionList,
  startAssessment,
  isAssessting,
  isLoading,
  match,
  taxpayer,
  selectedBirth,
  taxpayerProfile,
  permissions,
  approving,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const onStartAssessment = () => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want start assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const handlePurpose = (e) => {
    let purpose = '';
    switch (e) {
      case '1':
        purpose = 'CLAIM BENEFITS/LOAN';
        break;
      case '2':
        purpose = 'PASSPORT/TRAVEL';
        break;
      case '3':
        purpose = 'SCHOOL REQUIREMENTS';
        break;
      case '4':
        purpose = 'EMPLOYMENT LOCAL';
        break;
      case '5':
        purpose = 'EMPLOYMENT ABROAD';
        break;
      case '6':
        purpose = 'OTHERS';
        break;
      default:
        purpose = e;
        break;
    }
    return purpose;
  };

  const purposeVal = handlePurpose(_.get(taxpayer, 'purpose'));

  const handleDeliveryOption = (e) => {
    e.preventDefault();
    const status = _.get(transactionInfo, 'attributes.delivery_location') || 0;

    startAssessment(selectedBirth, () => {
      approveTransaction(
        selectedBirth,
        {
          remarks: status
            ? 'Document is ready for delivery'
            : 'Document is ready for pick-up',
          status: status ? 'FOR DELIVERY' : 'FOR PICK-UP',
        },
        () => {
          showTransaction(selectedBirth);
          setModal({ isOpen: false });
        }
      );
    });
  };

  const onReceive = (e) => {
    e.preventDefault();

    startAssessment(selectedBirth, () => {
      approveTransaction(
        selectedBirth,
        {
          remarks: 'The document was received',
          status: 'RECEIVED',
        },
        () => {
          getTransactionList();
          showTransaction(selectedBirth);
          setModal({ isOpen: false });
        }
      );
    });
  };

  const onPickup = (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to tag as for pick-up this application?',
      (remarks) => {
        startAssessment(selectedBirth, () => {
          approveTransaction(
            selectedBirth,
            {
              remarks,
              status: 'FOR PICK-UP',
            },
            () => {
              getTransactionList();
              showTransaction(selectedBirth);
              setModal({ isOpen: false });
            }
          );
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const RenderDeliveryOption = ({ status, loader }) => {
    return (
      <button
        disabled={loader}
        onClick={handleDeliveryOption}
        className="btn btn-warning btn-round font-weight-bold"
        type="button"
      >
        {status ? 'Tag as for Delivery' : 'Tag as for Pick-up'}
      </button>
    );
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1 ">
              {/* BORDER */}
              <div className="card border-primary p-2">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'first_name')} ${_.get(
                              taxpayer,
                              'middle_name'
                            )} ${_.get(taxpayer, 'last_name')}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${
                          _.get(taxpayer, 'middle_name') || ''
                        } ${_.get(taxpayer, 'last_name') || ''} ${
                          _.get(taxpayer, 'extension_name') || ''
                        }`}
                      </h1>
                    </div>

                    <div className="d-flex ml-auto">
                      {['PRINTED'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, ['FIND BIRTH CERTIFICATE']) && (
                          <RenderDeliveryOption
                            loader={approving || isAssessting}
                            status={_.get(
                              transactionInfo,
                              'attributes.delivery_location'
                            )}
                          />
                        )}
                      &nbsp;
                      {['FOR CHECKING'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, [
                          'START ASSESSMENT BIRTH CERTIFICATE',
                        ]) && (
                          <button
                            type="button"
                            onClick={onStartAssessment(transactionInfo)}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold"
                          >
                            Start Assessment&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}
                      {['FOR DELIVERY', 'FOR PICK-UP'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, [
                          'START ASSESSMENT BIRTH CERTIFICATE',
                        ]) && (
                          <button
                            disabled={approving || isAssessting}
                            type="button"
                            onClick={onReceive}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold"
                          >
                            Tag as Received&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}
                      {['FOR DELIVERY'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, [
                          'START ASSESSMENT BIRTH CERTIFICATE',
                        ]) && (
                          <button
                            disabled={approving || isAssessting}
                            type="button"
                            onClick={onPickup}
                            className="btn btn-danger btn-round font-weight-bold"
                          >
                            Tag as for PICK-UP&nbsp;
                            <i className="fas fa-check" />
                          </button>
                        )}
                    </div>
                  </div>
                  <TransactionInformation
                    transactionInfo={transactionInfo}
                    taxpayer={taxpayer}
                    module="psa"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-1 pb-1 px-3">
            <div className="col-12">
              <table className="transaction-table table table-borderless table-sm table-striped table-hover">
                <tbody>
                  <tr>
                    <td className="text-dark" width="300">
                      No. of Copies
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'number_of_copies') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Birth Reference Number
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'bren') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      What to Print
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'what_to_print') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success" colSpan={3}>
                      <b>DOCUMENT OWNER&apos;s PERSONAL INFORMATION</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'last_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'middle_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'first_name') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Extension Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'extension_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Sex
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{(_.get(taxpayer, 'gender') || '--').toUpperCase()}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Registered Late
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {_.get(taxpayer, 'is_registered_late')
                          ? moment(_.get(taxpayer, 'registered_when')).format(
                              'MM/DD/YYYY'
                            ) || '--'
                          : 'No' || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Born Abroad
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'born_abroad_country') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Date of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {moment(_.get(taxpayer, 'birth_date')).format(
                          'YYYY-MM-DD'
                        ) || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Place of Birth
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'place_of_birth_region_name') || '--'
                        ).toUpperCase()}{' '}
                        {(
                          _.get(taxpayer, 'place_of_birth_province_name') ||
                          '--'
                        ).toUpperCase()}{' '}
                        {(
                          _.get(taxpayer, 'place_of_birth_municipality_name') ||
                          '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success" colSpan={3}>
                      <b>DOCUMENT OWNER FATHER&apos;s NAME</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'fathers_last_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'fathers_middle_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'fathers_first_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success" colSpan={3}>
                      <b>DOCUMENT OWNER MOTHER&apos;s NAME</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mothers_last_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mothers_middle_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mothers_first_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Purpose
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>{purposeVal || '--'}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Specified Country
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'purpose_specify_country_name') ||
                          '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success" colSpan={3}>
                      <b>REQUESTOR&apos;s INFORMATION</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Last Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_last_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      First Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_first_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Middle Name
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'requestors_middle_name') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Mailing Address
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {' '}
                        {_.get(taxpayer, 'region_name') || '--'}
                        {''}
                        {_.get(taxpayer, 'province_name') || '--'}{' '}
                        {_.get(taxpayer, 'municipality_name') || '--'}{' '}
                        {_.get(taxpayer, 'barangay_name') || '--'}{' '}
                        {_.get(taxpayer, 'street') || '--'}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Zip Code
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mailing_zip_code') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Telephone No.
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'telephone_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Mobile Number.
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(
                          _.get(taxpayer, 'mobile_number') || '--'
                        ).toUpperCase()}
                      </b>
                    </td>
                  </tr>
                  <tr>
                    <td className="text-dark" width="300">
                      Tax Identification Number (TIN)
                    </td>
                    <td className="text-dark" width="1">
                      :
                    </td>
                    <td>
                      <b>
                        {(_.get(taxpayer, 'tin_number') || '--').toUpperCase()}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

BirthContent.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  selectedBirth: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  approving: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  approveTransaction: PropTypes.instanceOf(Function).isRequired,
  isAssessting: PropTypes.bool.isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  isAssessting: _.get(api, 'loading', []).indexOf(c.START_ASSESSMENT) > -1,
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  approving: _.get(api, 'loading', []).indexOf(c.APPROVE_TRANSACTION) > -1,
  selectedBirth: _.get(match, 'params.id') || '',
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(BirthContent);
